import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item']
  static values = {
    expanded: Boolean
  }

  initialize () {
    this.toggleVisibility()
  }

  toggle () {
    this.expandedValue = !this.expandedValue
  }

  toggleVisibility () {
    this.itemTargets.forEach(item => {
      item.classList.toggle('is-hidden', !this.expandedValue)
    })
  }

  expandedValueChanged () {
    this.toggleVisibility()
  }
}
